import * as React from 'react';
import OrganizationUser from '../../organization/models/OrganizationUser';
import Role from '../../organization/models/Role';
import HttpService from '../services/HttpService';
import * as moment from 'moment'
import { withRouter } from "react-router-dom";
import { Grid, TextField, Typography, Button, Divider, FormControl, InputLabel, Select, MenuItem, FormHelperText, Chip } from '@material-ui/core';
import Form from '../../shared/components/Form';
import BreadCrumb from '../../shared/components/BreadCrumb'
import * as _ from 'lodash';
import HttpCallConfig from '../models/HttpCallConfig'
import EditableChipList from '../../shared/components/EditableChipList';
import * as Languages from 'src/modules/consumer/models/Languages';
import {defaultProvider} from '../../../constants'

interface IState {
  availableRoles: Role[]
}
const httpService = HttpService.Instance;

class MyProfile extends React.Component<any, IState> {
  public formComponent: Form
  constructor(props: any) {
    super(props);
    this.state = {
      availableRoles: []
    }
    this.getUser = this.getUser.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  public renderEnvironmentRoles(item: any, environmentIds: any, label: string) {
    const roles = item.roles.filter((role: any) => environmentIds.includes(role.environmentId));
    if (!roles.length) {
      return null;
    }

    return (
      <EditableChipList
        items={roles}
        itemOptions={roles}
        labelProperty='name'
        disabled
        label={label}
        disbaleDoubles
      />
    );
  }

  public getUser() {
    return httpService.get(process.env.REACT_APP_API_URL + 'userprofile/')
      .then((response: Response) => response.json())
      .then((data: any) => {
        data.assets = this.AssetDataReducer(data)
        return data
      })
  }

  public async saveData(data: OrganizationUser) {
    const httpCallConfig = new HttpCallConfig;
    httpCallConfig.successMessage = 'Profile updated.'
    return await httpService.post(process.env.REACT_APP_API_URL + 'userprofile/', data, httpCallConfig)
  }

  public AssetDataReducer(user: OrganizationUser) {
    user.roles.forEach(role => {
      if (!role.assetName) { role.assetName = 'Generic' }
    });
    const assets = _(user.roles).groupBy('assetName')
      .map((roles, assetName) => ({ roles, name: assetName }))
      .value();
    return assets;
  }

  public render() {
    const hasCharacters = (value: string) => value.length <= 0
    const isActive = (this.formComponent && this.formComponent.formData && this.formComponent.formData.state.id === 4)
    const isConfirmed = (this.formComponent && this.formComponent.formData && this.formComponent.formData.state.id === 3)
    const isDefaultUserProvider = (this.formComponent && this.formComponent.formData && this.formComponent.formData.identityProvider === defaultProvider) ? true : false;
    return (
      <div>
        <Grid container={true} spacing={24} justify="space-between">
          <Grid item={true}>
            <Typography color="textSecondary" gutterBottom={true}>
              <BreadCrumb
                value='Console'
                to='/'
              />
              My Profile
            </Typography>
          </Grid>
          <Grid item={true}>
            {(isActive || isConfirmed) && isDefaultUserProvider &&
              <Button
                className="margin-top-24"
                size="small"
                mini={true}
                aria-label="Add"
                aria-haspopup="true"
                href={process.env.REACT_APP_PASSWORD_RESET_URL}
                target='_blank'
              >
                Reset password
              </Button>
            }
          </Grid>
        </Grid>
        <Form
          ref={(ref: Form) => this.formComponent = ref}
          history={this.props.history}
          saveFormPromise={this.saveData}
          getFormPromise={this.getUser}
          refreshHandler={
            (callback?: () => void) => {
              this.forceUpdate(() => {
                if (callback) { callback() }
              })
            }
          }
        >
          {this.formComponent && this.formComponent.formData && this.formComponent.formData.identityProvider !== defaultProvider &&
            <div className="padding-bottom-24">
              <Chip className='full-width' label={"This user is linked with external entity provider " + this.formComponent.formData.identityProvider + ". Some functionality is limited."} />
            </div>
          }
          {this.formComponent && this.formComponent.formShadowData &&
            <div>
              <Grid container={true} spacing={24}>
                <Grid item={true} xs={12}>
                  <TextField
                    name="email"
                    disabled={true}
                    label="Email"
                    fullWidth={true}
                    value={this.formComponent.formShadowData.email}
                    onChange={(e: any) => {
                      this.formComponent.onChangeHandler(e, { validation: hasCharacters })
                    }}
                    margin="normal"
                    required={true}
                    error={hasCharacters(this.formComponent.formShadowData.email)}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="firstName"
                    label="First Name"
                    value={this.formComponent.formShadowData.firstName}
                    onChange={(e: any) => {
                      this.formComponent.onChangeHandler(e, { validation: hasCharacters })
                    }}
                    margin="normal"
                    required={true}
                    error={hasCharacters(this.formComponent.formShadowData.firstName)}  
                    disabled={!isDefaultUserProvider}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="lastName"
                    label="Last Name"
                    value={this.formComponent.formShadowData.lastName}
                    onChange={(e: any) => {
                      this.formComponent.onChangeHandler(e, { validation: hasCharacters })
                    }}
                    margin="normal"
                    required={true}
                    error={hasCharacters(this.formComponent.formShadowData.lastName)}
                    disabled={!isDefaultUserProvider}
                  />
                </Grid>
              </Grid>
              <Grid container={true} spacing={24}>
                <Grid item={true}>
                  <TextField
                    name="subdivision"
                    disabled={true}
                    label="Subdivision"
                    value={this.formComponent.formShadowData.subdivision}
                    onChange={(e: any) => { this.formComponent.onChangeHandler(e); }}
                    margin="normal"
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="stateName"
                    label="State"
                    disabled={true}
                    value={this.formComponent.formShadowData.state.name}
                    margin="normal"
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="dateAdded"
                    label="Date Added"
                    disabled={true}
                    value={moment(this.formComponent.formShadowData.dateAdded).format('YYYY-MM-DD')}
                    margin="normal"
                  />
                </Grid>
              </Grid>
              <Grid container={true} spacing={24} className="padding-bottom-24">
                <Grid item={true}>
                  <FormControl margin="normal" required>
                    <InputLabel>Preferred Language</InputLabel>
                    <Select
                      name="preferredLanguageId"
                      style={{width: 195}}
                      value={
                        this.formComponent.formShadowData.preferredLanguageId
                      }
                      onChange={(e: any) => {
                        this.formComponent.onChangeHandler(e);
                      }}
                      disabled={!isDefaultUserProvider}
                    >
                      {Object.values(Languages).map(language => (
                        <MenuItem key={language.id} value={language.id}>
                          {language.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>For limited use cases only</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <div className="padding-bottom-24" />
              <Divider />
              <div className="padding-bottom-24" />
              {this.formComponent.formShadowData.assets && this.formComponent.formShadowData.assets.map((asset: any, index: number) =>
                <div key={index} className="padding-bottom-24">
                  <Typography variant="subheading" gutterBottom={true}>
                    {asset.name + ' roles'}
                  </Typography>
                  {this.renderEnvironmentRoles(asset, [0, null, undefined], 'All environments')}
                  {this.renderEnvironmentRoles(asset, [2], 'Live')}
                  {this.renderEnvironmentRoles(asset, [1], 'Sandbox')}
                </div>
              )}
              { !this.formComponent.formShadowData.termsAndConditionsTarget &&
                <Typography variant="caption">Check your contract for the accepted terms and conditions.</Typography>
              }
              { this.formComponent.formShadowData.termsAndConditionsTarget && this.formComponent.formShadowData.termsAndConditionsTarget === this.formComponent.formShadowData.termsAndConditionsVersion &&
                <Typography variant="caption">Click <a href="https://www.nxtport.com/general-terms-conditions" target="_blank">here</a> to read NxtPort's general terms and conditions.</Typography>
              }
              { this.formComponent.formShadowData.termsAndConditionsTarget && this.formComponent.formShadowData.termsAndConditionsTarget !== this.formComponent.formShadowData.termsAndConditionsVersion &&
                <Typography variant="caption">Your accepted terms and conditions are outdated. Please log out and back in to accept the new terms and conditions: <a href="https://www.nxtport.com/general-terms-conditions" target="_blank">https://www.nxtport.com/general-terms-conditions</a></Typography>
              }
            </div>
          }
        </Form>
      </div>
    )
  }
}

export default withRouter(MyProfile)



// WEBPACK FOOTER //
// ./src/modules/core/pages/MyProfile.tsx